import React from "react";
import { useLanguage } from "./Language.js";

const AboutTab = () => {

  const {language} = useLanguage();
  
  return (
    <div>
      {language === "en" ? (
        <>
          <h2>About Gaelic Connect?</h2>
          <p>Gaelic Connect is a web app that uses maps to help speakers and learners of Scottish Gaelic in Glasgow to find events 
            and spaces to use Gaelic, and to develop community networks.</p>
          <p>The app was developed as a response to a survey conducted in 2022, which found that Gaelic speakers in Glasgow need more 
            opportunities to use Gaelic informally and more information about Gaelic events in the city. This app will serve as a digital 
            hub where Glaswegians can visualise and access the Gaelic going on around them.</p>
          <p>In the app, you can use the map to explore Glasgow's Gaelic landscape, see where Gaelic is being used right now, and access information 
            about Gaelic events being held all around the city.</p>
          <p>In the Gaelic Connect app, you can unlock badges the more you use the app. Badges are levels of achievement that you can earn. You can unlock 
            different achievement badges based on how often you use the app, and how much you engage with Gaelic in your Glasgow community.</p>
          <p>Start your Gaelic Connect journey with us!</p>
          
        </>
      ) : (
        <>
          <h2>Dè th' ann an Ceangal Gàidhlig?</h2>
          <p>Is e app eadar-lìn a th' ann an Ceangal Gàidhlig, a tha a' cleachdadh mhapaichean gus luchd-labhairt agus 
            luchd- ionnsachaidh Gàidhlig na h-Alba ann an Glaschu, a chuideachadh le tachartasan agus àiteachan a lorg airson 
            Gàidhlig a chleachdadh agus lìonraidhean coimhearsnachd a leasachadh.</p>
          <p>Chaidh an app a chur air bhonn mar fhreagairt do shuirbhidh a chuireadh an gnìomh ann an 2022, a lorg gu bheil 
            feum aig luchd-labhairt na Gàidhlig ann an Glaschu air barrachd chothroman gus Gàidhlig a chleachdadh gu neo-fhoirmeil 
            agus nas motha fiosrachaidh fhaotainn mu thachartasan Gàidhlig sa bhaile. Bidh an app seo a' frithealadh 
            mar mhòr-ionad dhidseatach far am faod muinntir Ghlaschu a' Ghàidhlig a tha a' dol mun cuairt orra a 
            lèir-shamhlachadh agus inntrigeadh.</p>
          <p>San app, faodaidh tu am mapa a chleachdadh gus cruth-tìre Gàidhlig Ghlaschu a rannsachadh, faicinn far a 
            bheil Gàidhlig ga cleachdadh aig an dearbh àm seo, agus cothrom fhaotainn air fiosrachadh mu thachartasan 
            Gàidhlig a tha gan cumail air feadh a' bhaile.</p>
          <p>San app Ceangal Gàidhlig, is urrainn dhut bràistean fhosgladh mar as motha a chleachdas tu an app. 
            Tha na bràistean a' nochdadh nan ìrean coileanaidh as urrainn dhut a chosnadh. Faodaidh tu diofar 
            bhràistean coileanaidh fhosgladh a rèir cho tric 's a chleachdas tu an app, agus a rèir na h-ìre gu 
            bheil thu a' cleachdadh na Gàidhlig nad choimhearsnachd ann an Glaschu.</p>
          <p>Tòisich air do shlighe Ceangal Gàidhlig còmhla rinn!</p>
        </>
      )}
    </div>
  );
};

export default AboutTab;